








import { VueCustom } from 'vue-custom';
import Game from 'components/game.vue';
import AudioExtension from 'components/audio-extension.vue';

export default VueCustom.extend({
  name: 'app',
  components: {
    Game,
    Popups: () => import(/* webpackChunkName: "popups" */ 'components/popups/index.vue'),
    AudioExtension,
  },
  computed: {
    isGameReady(): boolean {
      return this.$store.getters.isGameReady;
    },
  },
});
